<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Contacts">
        <v-card>
          <v-card-title>Adresses mails scolarité </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="item in sites" :key="item.site">
                <v-row>
                  <v-col cols="4">
                    <b>{{ item.site }}</b
                    >:
                  </v-col>

                  <v-col>
                    <a :href="item.mailto">{{ item.mail }}</a>
                  </v-col>
                </v-row>
              </li>
            </ul>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            Adresse mail de la Direction de l’Orientation
          </v-card-title>
          <v-card-text>
            <ul>
              <li>
                <v-row>
                  <v-col cols="4">
                    <b>{{ suaio.libelle }}</b
                    >:
                  </v-col>

                  <v-col
                    ><a :href="suaio.mailto">{{ suaio.mail }}</a></v-col
                  >
                </v-row>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Contacts",
  components: { BaseBlock },

  data() {
    return {
      sites: [
        {
          site: "Cité scientifique",
          mail: "scolarite-relais-citescientifique@univ-lille.fr",
          mailto: "mailto:scolarite-relais-citescientifique@univ-lille.fr",
        },
        {
          site: "IUT Villeneuve d'Ascq",
          mail: "iut-a-scolarite@univ-lille.fr",
          mailto: "mailto:iut-a-scolarite@univ-lille.fr",
        },
        {
          site: "Moulins-Lille",
          mail: "scolarite-relais-moulinslille@univ-lille.fr",
          mailto: "mailto:scolarite-relais-moulinslille@univ-lille.fr",
        },
        {
          site: "Santé",
          mail: "scolarite-relais-sante@univ-lille.fr",
          mailto: "mailto:scolarite-relais-sante@univ-lille.fr",
        },
        {
          site: "Pont de Bois",
          mail: "scolarite-relais-pontdebois@univ-lille.fr",
          mailto: "mailto:scolarite-relais-pontdebois@univ-lille.fr",
        },
        {
          site: "IUT Tourcoing",
          mail: "iut-tourcoing-scolarite@univ-lille.fr",
          mailto: "mailto:iut-tourcoing-scolarite@univ-lille.fr",
        },
      ],
      suaio: {
        libelle: "Direction de l’Orientation",
        mail: "orientation@univ-lille.fr",
        mailto: "mailto:orientation@univ-lille.fr",
      },
    };
  },
};
</script>
